module.exports = __webpack_public_path__ + "img/logo@2x.aae9625c.png";